import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

const policyLinks = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/returns", label: "Returns" },
  { to: "/shipping", label: "Shipping" },
  { to: "/size-guide", label: "Size Guide" },
  { to: "/trade-in", label: "Trade-In Terms" },
];

const shopLinks = [
  { to: "/shop", label: "All Jackets" },
  { to: "/personalize", label: "Personalize" },
  { to: "/vip", label: "VIP & Trade-In" },
  { to: "/size-guide", label: "Size Guide" },
];

const aboutLinks = [
  { to: "/about", label: "Our Story" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="font-serif text-3xl tracking-[0.18em] text-white">
              BOSCAGE
            </Link>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70">
              Premium leather outerwear, numbered and guaranteed for life.
              Hand-finished by master craftspeople.
            </p>

            <address className="not-italic mt-6 space-y-2 text-sm text-white/80">
              <a
                href="mailto:hello@boscage.com"
                data-testid="footer-email"
                className="inline-flex items-start gap-3 hover:text-[#c9a84c] transition-colors"
              >
                <Mail size={16} strokeWidth={1.5} className="mt-[2px] text-[#c9a84c]" />
                hello@boscage.com
              </a>
              <p data-testid="footer-address" className="inline-flex items-start gap-3 text-white/70 leading-relaxed">
                <MapPin size={16} strokeWidth={1.5} className="mt-[2px] text-[#c9a84c] shrink-0" />
                5856 Mount Vernon Dr, VA,
                <br />
                Alexandria, VA 22303, United States
              </p>
            </address>

            <div className="flex items-center gap-4 mt-8">
              <a
                href="https://www.instagram.com/boscage.official/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-link-instagram"
                aria-label="Instagram"
                className="text-white/60 hover:text-[#c9a84c] transition-colors"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <FooterCol title="Shop" links={shopLinks} />
          <FooterCol title="Maison" links={aboutLinks} />
          <FooterCol title="Policies" links={policyLinks} />
        </div>

        <div className="my-10 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] tracking-[0.22em] uppercase text-white/50">
          <span>© {new Date().getFullYear()} BOSCAGE Elegance</span>
          <span>hello@boscage.com  ·  Alexandria, VA · USA</span>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div className="md:col-span-2">
    <h4 className="text-[11px] tracking-[0.28em] uppercase text-[#c9a84c] mb-5 font-semibold">
      {title}
    </h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link
            to={l.to}
            data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s/]+/g, "-")}`}
            className="text-sm text-white/70 hover:text-[#c9a84c] transition-colors"
          >
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
